var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgError = function SvgError(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.8793 6.15127L14.0305 11L18.8793 15.8487L17.263 17.465L12.4143 12.6162L7.56556 17.465L5.94932 15.8487L10.7981 11L5.94932 6.15127L7.56556 4.53502L12.4143 9.38376L17.263 4.53502L18.8793 6.15127Z",
    fill: "currentColor"
  })));
};

export { SvgError as ReactComponent };
export default __webpack_public_path__ + "689b6a9b4d8c774f4bbefc8126893989.svg";